export default __webpack_public_path__ + "static/media/bothIcon.89e664d4.svg";